

<div class="mms-worksheet p-20 m-0-auto">

    <!-- Header -->
    <div class="mms-ws-header" *ngIf="header">
      <div class="flex flex-horiz-space-bw">
        <div>
          <img [src]="header.logo" alt="/assets/images/logos/mmslogo.png" class="mms-ws-header-logo"/>
        </div>
        <!-- <div class="mms-ws-header-addr">
            <h5>MetaMorphoSys Insurance Corp.</h5>
            <p>Himgiri Bungalow, LA-Ratan Lane</p>
            <p>Baner, MH 411045</p>
        </div> -->
      </div>
    </div>
  
    <div *ngFor="let section of summarySectionsList; let pSectionIndex = index;let pSectionLast = last;">
      <div class="title-emphasis" *ngIf="section.titleWithIcon">
        <i nz-icon class="title-ico" [nzType]="section.icon"></i>
        <div>
          <h4 class="p-0 m-0">{{section.titleWithIcon}}</h4>
          <span class="col-grey-dark">{{section.titleDesc}}</span>
        </div>
      </div>

      <div *ngIf="section.heading">
        <h3 class="d-b m-t-20 heading">{{section.heading}}</h3>
      </div>

      <ng-container [ngSwitch]="section.sectionType">
        <div *ngSwitchCase="'form'">
        
          <div class="summary-container summary-container-wide">
            <div *ngFor="let sData of section.sectionData">
              <span class="s-c-head">{{sData.label}}</span>
              <ng-container *ngIf="sData.value; else showNullData">
                <span *ngIf="sData.showTag">
                  <ng-container *ngIf="sData.pipe; else showOnlyTag">
                    <ng-container [ngSwitch]="sData.pipe">
                      <nz-tag *ngSwitchCase="'date'" [nzColor]="sData.tagColor">{{sData.value | date :
                        appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR}}</nz-tag>
                      <nz-tag *ngSwitchCase="'technicalTranslate'" [nzColor]="sData.tagColor">{{sData.value |
                        technicalTranslate}}</nz-tag>
                    </ng-container>
                  </ng-container>
                  <ng-template #showOnlyTag>
                    <nz-tag [nzColor]="sData.tagColor">{{sData.value}}</nz-tag>
                  </ng-template>
                </span>
        
                <span *ngIf="sData.showBadge">
                  <ng-container *ngIf="sData.pipe; else showOnlyBadge">
                    <ng-container [ngSwitch]="sData.pipe">
                      <nz-badge *ngSwitchCase="'date'" [nzStatus]="sData.badgeStatus">{{sData.value | date :
                        appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR}}</nz-badge>
                      <nz-badge *ngSwitchCase="'technicalTranslate'" [nzStatus]="sData.badgeStatus">{{sData.value |
                        technicalTranslate}}</nz-badge>
                    </ng-container>
                  </ng-container>
                  <ng-template #showOnlyBadge>
                    <nz-badge [nzStatus]="sData.badgeStatus">{{sData.value}}</nz-badge>
                  </ng-template>
                </span>
        
                <span *ngIf="!sData.showTag && !sData.showBadge">
                  <ng-container *ngIf="sData.pipe; else showOnlyData">
                    <ng-container [ngSwitch]="sData.pipe">
                     <input *ngSwitchCase="'date'" type="text" [value]="sData.value | date: appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR" 
                      class="b-0 d-i-b m-l-5 multi-line-input" readonly 
                      (input)="updateValue($event.target.value, sData.key)"/>
               
                      <!-- <input *ngSwitchCase="'technicalTranslate'" type="text" [value]="sData.value | technicalTranslate :sData.pipeValue " 
                      class="b-0 d-i-b m-l-5 multi-line-input" 
                      (input)="updateValue($event.target.value, sData.key)"/> -->
                      <!-- lookup - {{sData.pipeValue}} : {{lookup$[sData.pipeValue] |json}} -->
                      <nz-select *ngSwitchCase="'technicalTranslate'" class="b-0 d-i-b m-l-5 multi-line-input" nzShowSearch [nzShowArrow]="false" [(ngModel)]="sData.value" style="width: 80%"  nzSize="small" (ngModelChange)="updateValue(sData.value, sData.key)" >
                       <nz-option
                              *ngFor="let item of (lookup$[sData.pipeValue] | async) as LookupList; trackBy:item?.lookupKey"
                              [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                     </nz-select>
                    </ng-container>
                  </ng-container>
                  <ng-template #showOnlyData>
                    <input type="text" [(ngModel)]="sData.value" class="b-0 d-i-b m-l-5 multi-line-input" />
                  </ng-template>
                </span>
        
                <small class="d-b" *ngIf="sData.additionalValue">( {{sData.additionalValue}} )</small>
              </ng-container>
              <ng-template #showNullData>
                <input type="text"
                [ngModel]="sData.value !== null && sData.value !== undefined && sData.value !== '' ? sData.value : '-'"
                (ngModelChange)="updateValue($event, sData.key)"
                (focus)="onFocus($event)"
                class="b-0 d-i-b m-l-5 multi-line-input"/>
                <!-- <input type="text" [(ngModel)]="sData.value" class="b-0 d-i-b m-l-5 multi-line-input" /> -->
              </ng-template>
        
            </div>
        
          </div>
        </div>

        <div *ngSwitchCase="'grid'">
          <nz-table *ngIf="section.sectionData" #dataListTable nzBordered nzTableLayout="fixed" nzSize="small" 
            [nzData]="section.sectionData?.displayData" [nzScroll]="{x: '480px'}" [nzFrontPagination]="section.sectionData.displayData && section.sectionData.displayData.length > 5 ? true : false" >
            <thead (nzSortOrderChange)="sort($event)" nzSingleSort>
                <tr>
                    <ng-container *ngFor="let item of section.sectionData.listHeader">
                        <ng-container *ngIf="item.isVisible">
                            <th *ngIf="item.sortFilter && item.searchFilter; else showHeaderWithSortOnly" nzCustomFilter
                                nzShowSort [nzColumnKey]="item.key" [nzWidth]="item.width">
                                {{item.header}}
                                <nz-filter-trigger [nzDropdownMenu]="searchFilterMenu"
                                    (nzVisibleChange)="filterMenuVisibilityChanged($event)">
                                    <i nz-icon nzType="search" (click)="getConfigKey(item.key)"></i>
                                </nz-filter-trigger>
                            </th>
                            <ng-template #showHeaderWithSortOnly>
                                <th *ngIf="item.sortFilter; else showSearchFilterOnly" nzShowSort [nzColumnKey]="item.key"
                                    [nzWidth]="item.width">
                                    {{item.header}}
                                </th>
                            </ng-template>
                            <ng-template #showSearchFilterOnly>
                                <th *ngIf="item.searchFilter; else showOnlyTableHeader" nzCustomFilter [nzColumnKey]="item.key"
                                    [nzWidth]="item.width">
                                    {{item.header}}
                                    <nz-filter-trigger [nzDropdownMenu]="searchFilterMenu"
                                        (nzVisibleChange)="filterMenuVisibilityChanged($event)">
                                        <i nz-icon nzType="search" (click)="getConfigKey(item.key)"></i>
                                    </nz-filter-trigger>
                                </th>
                            </ng-template>
                            <ng-template #showOnlyTableHeader>
                                <th [nzWidth]="item.width">{{item.header}}</th>
                            </ng-template>
        
        
                        </ng-container>
                    </ng-container>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of dataListTable.data">
                    <ng-container *ngFor="let config of section.sectionData.listHeader">
                        <ng-container *ngIf="config.isVisible">
                            <td *ngIf="config.applyColor; else showDataWithoutColor" nz-typography
                                [nzType]="data['color'] == 'error' ? 'danger' : data['color']">
                                <span *ngIf="config.pipe;else showColoredDataOnly">{{ (data[config.key] | technicalTranslate) ||
                                    '-' }}</span>
                                <ng-template #showColoredDataOnly>{{ data[config.key] || '-' }}</ng-template>
                            </td>
                            <ng-template #showDataWithoutColor>
                                <td>
                                    <!-- <span *ngIf="config.pipe;else showDataOnly">{{ (data[config.key] | technicalTranslate) ||
                                        '-' }}</span> -->
                                    <ng-cintainer *ngIf="config.pipe;else showDataOnly">
                                      <ng-container [ngSwitch]="config.pipe">
                                         <!-- <input *ngSwitchCase="'technicalTranslate'" type="text" [value]="data[config.key] | technicalTranslate" 
                                          class="b-0 d-i-b m-l-5 multi-line-input" 
                                          (input)="updateValue($event.target.value, config.key)"/> -->
                                          <nz-select *ngSwitchCase="'technicalTranslate'" class="b-0 d-i-b m-l-5 multi-line-input" nzShowSearch [nzShowArrow]="false" [(ngModel)]="data[config.key].value " style="width: 80%"  nzSize="small" (ngModelChange)="updateValue($event.target.value, sData.key)" >
                                            <nz-option *ngFor="let option of lookup$[config.pipeValue]" [nzLabel]="option.lookupValue" [nzValue]="option.lookupKey"></nz-option>
                                          </nz-select>
                                          <input *ngSwitchCase="'date'" type="text" [value]="data[config.key] | technicalTranslate" 
                                          class="b-0 d-i-b m-l-5 multi-line-input" 
                                          (input)="updateValue($event.target.value, config.key)"/>
                                      </ng-container>
                                    </ng-cintainer>
                                    <ng-template #showDataOnly>
                                      <input type="text" [(ngModel)]="data[config.key]['value']" (ngModelChange)="updateValue($event, config.key)"class="b-0 d-i-b m-l-5 multi-line-input" />
                                      <!-- {{ data[config.key] || '-' }} -->
                                    </ng-template>
                                </td>
                            </ng-template>
                        </ng-container>
                    </ng-container>
                </tr>
            </tbody>
        </nz-table>
        
        <!-- <nz-dropdown-menu #searchFilterMenu="nzDropdownMenu">
            <div class="ant-table-filter-dropdown">
                <div class="search-box">
                    <input type="text" nz-input placeholder="Filter..." [(ngModel)]="searchValue" />
                    <button nz-button nzSize="small" nzType="primary" (click)="searchConfiguration(searchValue)"
                        class="search-button">
                        Filter
                    </button>
                    <button nz-button nzSize="small" (click)="reset()">Reset</button>
                </div>
            </div>
        </nz-dropdown-menu> -->
        
        <app-generic-zero-ui [list]="sectionData" icon="question-circle" title="No Data"
             message="No Data found in the List"></app-generic-zero-ui>
        </div>

        <div *ngSwitchCase="'explanation-text'">
          <div [innerHtml]="section.sectionData.desc"></div> 
          <span> </span>       
        </div>

        <div *ngSwitchCase="'timeline'">
          <nz-timeline>
            <nz-timeline-item  *ngFor="let sData of section.sectionData" [nzColor]="sData.timelineColor">
              <h4 class="f-w-600">{{sData.title}} <nz-tag [nzColor]="sData.statusColor">{{sData.status}}</nz-tag></h4>
              <p><i nz-icon [nzType]="sData.icon"></i>{{sData.date}}  ({{sData.calcDays}})</p>
              <div *ngFor="let item of sData.addData">
                <div>{{item.key}} : {{item.value}}</div>
              </div>
            </nz-timeline-item>
    
          </nz-timeline>
        </div>
      </ng-container>

      <div *ngIf="!pSectionLast" class="m-t-40"></div>
    </div>

  </div>